var _g, _text, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 18,
    viewBox: "0 0 66 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#15b5d8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 18,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 17,
    rx: 1.5,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(40.25 13.5)",
    fill: "#15b5d8",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.899,
    y: 0
  }, "LINK"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.912 3.412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.536.767l-2.272,2.272s-.007.01-.011.014a3.283,3.283,0,0,1,1.667.182l1.542-1.542a1.31,1.31,0,0,1,1.852,1.852l-2.272,2.272a1.324,1.324,0,0,1-1.852,0,.656.656,0,0,0-.926,0l-.4.4a2.6,2.6,0,0,0,.4.529,2.638,2.638,0,0,0,3.69.011l.014-.011,2.272-2.272a2.619,2.619,0,1,0-3.7-3.7Z",
    transform: "translate(-180.831)",
    fill: "#15b5d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.093,172.353,3.546,173.9a1.31,1.31,0,1,1-1.852-1.852l2.276-2.276a1.324,1.324,0,0,1,1.852,0,.656.656,0,0,0,.926,0l.4-.4a2.6,2.6,0,0,0-.4-.529,2.637,2.637,0,0,0-3.69-.011l-.014.011L.768,171.122a2.619,2.619,0,0,0,3.7,3.7l2.276-2.277s.007-.01.011-.014a3.283,3.283,0,0,1-1.667-.182Z",
    transform: "translate(0 -164.417)",
    fill: "#15b5d8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/Link_Icon.1e9fe7c7c0bad83d6dab0384d8600247.svg";
export { ForwardRef as ReactComponent };